module.exports = __webpack_public_path__ + "static/media/icon-info.b53b9e83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-info.svg
// module id = 1461
// module chunks = 0